import moment               from 'moment';
import { appConfig }        from '../../config';
import {
  getQMEData, postQMEData
}                           from '../../services/API';
import {
  fetchMockstatsTableData
}                           from '../../services/fetchMocks';
import * as ReduxTypes      from '../types';

const REQUEST_PCM_DATA   = 'REQUEST_PCM_DATA';
const RECEIVED_PCM_DATA  = 'RECEIVED_PCM_DATA';
const ERROR_PCM_DATA     = 'ERROR_PCM_DATA';
const CLEAR_PCM_DATA     = 'CLEAR_PCM_DATA';

let pcm = {
  isFetching: false,
  // data:   {"customer_qme_tag":{}},
  data: null,
  time:       null
};

let initialStateCopy = {};
  for (var property in appConfig.pcm.data) {
      // console.log(property);
      // console.log(appConfig.gameinfo.data.hasOwnProperty(property));
      // console.log(Object.getOwnPropertyNames(appConfig.gameinfo.data));
    if (appConfig.pcm.data.hasOwnProperty(property) && property != "API") {
        initialStateCopy[property] = Object.assign({}, pcm);
        initialStateCopy[`reset::${property}`] = Object.assign({}, pcm);
    }
  } 
  const initialState = initialStateCopy;

export default function pcm(state = initialState, action) {
    console.log(initialState);
    console.log("pcm plan call - API");
    console.log(appConfig.pcm.data);
    console.log(action);
    let data = initialState;
    // return state
    switch (action.type) {
    case 'CHANGE_LOCATION_FOR_PCM':
      console.log("SH - REQUEST_LOCATION_CHANGE");
      console.log(state);
      data[action.name].requested_venue_id = action.selectedLocation;
      return Object.assign({}, state, data);
    case 'REFRESH_PCM_DATA':
      console.log("SH- REFRESH_PCM_DATA");
      fetchPCMDataIfNeeded(action.venue_id,action.name);
      return state;        
    case 'REQUEST_PCM_DATA':
      console.log("SH - REQUEST_PCM_DATA data");
      console.log(state);
      console.log(action);
      console.log(data);
      data[action.name].isFetching = action.isFetching;
      data[action.name].time = action.time;
      return Object.assign({}, state, data);
    case 'RECEIVED_PCM_DATA':
      console.log("SH - RECEIVED_PCM_DATA data");
      console.log(action);
      console.log(state);
      data[action.name].isFetching = action.isFetching;
      data[action.name].time = action.time;
      // data[action.name].headers = action.headers;
      data[action.name].data = action.data;
      // data[action.name].venue_id = action.venue_id;
      let newstate = Object.assign({}, state, data);
      console.log(newstate);
      return newstate;
    case 'CLEAR_PCM_DATA':
      data[action.name].time = action.time;
      data[action.name].data = [[]];        
    case 'ERROR_PCM_DATA':
      data[action.name].isFetching = action.isFetching;
      data[action.name].time = action.time;
      // data[action.name].headers = [];
      data[action.name].data = [[]];
      //To avoid api loop
      //Stop at first api error.
      // data[action.name].venue_id = state[action.name].requested_venue_id;    
      return Object.assign({}, state, data);
    default:
      return state;
    }
}

 

export function fetchPCMDataIfNeeded(name, customer_id, pcm_id) {
    console.log("SP ifNeeded");
    console.log(name);
  return (
    dispatch, 
    getState
  ) => {
  
    if (shouldFetchPCMData(getState(), name)) {
      return dispatch(fetchPCMData(name, customer_id, pcm_id));
    }
  };
}

export function clearPCMDataIfNeeded(name) {
  return (
    dispatch, 
    getState
  ) => dispatch(clearPCMData(name));
}

function clearPCMData(name,time = moment().format()) {
  return {
    type:       CLEAR_PCM_DATA,
    isFetching: false,
    time,name
  };
}



export function throwPCMDataHandler(name, payload) {
  console.log("SP if throw handler");
return (
  dispatch, 
  getState
) => dispatch(throwPCMData(name, payload));
}

function requestPCMData(name,time = moment().format()) {
  return {
    type:       REQUEST_PCM_DATA,
    isFetching: true,
    time,name
  };
}

function receivedPCMData(data,name, time = moment().format()) {
  console.log("receivedPCMData");
  console.log(data);
  return {
    type:       RECEIVED_PCM_DATA,
    isFetching: false,
    data:   data,
    time,name
  };
}

function errorPCMData(error,name, time = moment().format()) {
  return {
    type:       ERROR_PCM_DATA,
    isFetching: false,
    error,
    time,name
  };
}

function fetchPCMData(name, customer_id, pcm_id) {
  return dispatch => {
    dispatch(requestPCMData(name));
      getQMEData(name, `?customer_id=${customer_id}`, `pcm_id=${pcm_id}`)
        .then(
          data => dispatch(receivedPCMData(data,name))
        )
        .catch(
          error => dispatch(errorPCMData(error,name))
        );
  };
}

function throwPCMData(name, payload) {
  // console.log(id);
  console.log(name);
  console.log("SH throwPCMData");
return dispatch => {
  dispatch(requestPCMData(name));
  if(name.split("::")[0] == "reset"){
      dispatch(receivedPCMData(null,name.split("::")[1] ));
  } else if(name != ""){
    postQMEData(name, payload)
      .then(
        data => dispatch(receivedPCMData(data,name))
      )
      .catch(
        error => dispatch(errorPCMData(error,name))
      );      
    }else{
      //Redux data clearing request.
      dispatch(receivedPCMData({"venue_id":-1,"data":[[]],"headers":[],"title":"Empty"},name))
    }

};
}

function shouldFetchPCMData(state,name) {
  const spStore = state.pcm[name];
  console.log(state);
  if (spStore.isFetching) {
    return false;
  } else {
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/app/redux/modules/pcm.js